/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { PortalWebsite, PortalWebsiteApi } from '@api/model';
import { PortslWebsiteUpdateFields } from 'src/js/models/Portal';
import { DefaultHttpService } from './HttpService';

class PortalWebsiteService {

  readonly plainApi = new DefaultHttpService();

  readonly settingsApi = new PortalWebsiteApi(this.plainApi);

  public getPortalPortalWebsites(): Promise<PortalWebsite[]> {
    return this.settingsApi.getPortalWebsites();
  }

  public updatePortalWebsite(...args: PortslWebsiteUpdateFields): Promise<any> {
    return this.settingsApi.updatePortalWebsite(
      ...args
    );
  }

  public deletePortalWebsite(id: number): Promise<any> {
    return this.settingsApi.deletePortalWebsite(id);
  }
}

export default new PortalWebsiteService();